<div *ngIf="isLoading | async" class="loading-indicator">
  <p-progressSpinner strokeWidth="4" ></p-progressSpinner>
</div>